import { Module } from 'vuex'
import { RootState } from '../types'
import { ProfileState } from './types'
import { state } from './state'
import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'

export const profile: Module<ProfileState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
